import router from './router'
import useBookStore from './store'
import BookMessages from './localization'

export default {
  router,
  useBookStore,
  localization: BookMessages,
}
